import { ReactElement } from 'react'

import { BankAccountStatus } from '@features/bankAccounts/enums/bankAccountStatus'
import { BankAccount } from '@features/bankAccounts/types/bankAccount'

import { CardActionType } from '../../enums/cardActionType'
import { SyncStatus } from '../../enums/syncStatus'
import { BaseAccountCard } from '../BaseAccountCard'

interface ConnectedBankAccountCardProps {
  accountNo?: number
  bankAccount: BankAccount
}

export const BankAccountCard = ({ accountNo, bankAccount }: ConnectedBankAccountCardProps): ReactElement => {
  const { id, bankName, accountName, customAccountName, iban, bookedBalance, currency, bookkeepingAccountId, status } =
    bankAccount
  const syncStatus = status === BankAccountStatus.CLOSED ? SyncStatus.Closed : SyncStatus.Realtime

  return (
    <BaseAccountCard
      account={{
        accountName,
        bankAccountId: id,
        customAccountName,
        iban,
        accountNo,
        externalAccountId: bookkeepingAccountId,
        totalAmount: bookedBalance?.value,
        currency,
      }}
      actionItems={[CardActionType.DownloadTransactions, CardActionType.EditAccountName, CardActionType.HideAccount]}
      bankName={bankName}
      syncStatus={syncStatus}
    />
  )
}
